module.exports = __webpack_public_path__ + "c5ca1f9168a3fdea82dcd9755d88747d.svg";